import React, { useEffect, useState } from "react";
import { Typography, Stack, Box, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useQuery } from "@apollo/client";

// src
import "./dashboardcard.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
// icon
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { RiUser3Line } from "react-icons/ri";
import { RiUserUnfollowLine } from "react-icons/ri";
import { RiUserFollowLine } from "react-icons/ri";
import { GrDocumentUser } from "react-icons/gr";
import { FaUsers } from "react-icons/fa6";
import { GET_TOTAL_STUDENT_FOR_DASHBOARD, GET_TOTAL_DROP_OUT, GET_ACTIVE_STUDENT, GET_CERTIFICATE_OFFER, GET_OVERALL_ATT_RATE } from "../../Schema/Dashboard";

export default function DashboardCard({
  academicYearId,
  schoolId,
  levelID,
  groupID,
  teacherId,
}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);

  const [totalStudentData, setTotalStudentData] = useState();
  const [totalStudentDropOut, setTotalStudentDropOut] = useState();
  const [totalStudentActive, setTotalStudentActive] = useState();
  const [totalStudentCertificateOffer, setTotalStudentCertificateOffer] = useState();
  const [overallRateData, setOverallRateData] = useState();

  const { refetch } = useQuery(GET_TOTAL_STUDENT_FOR_DASHBOARD, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelID ?? null,
      groupId: groupID ?? null,
      teacherId: teacherId ?? null,
    },
    onCompleted: ({ getTotalStudentForDashboard }) => {
      setTotalStudentData(getTotalStudentForDashboard);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  const { refetch: refetchDropOut } = useQuery(GET_TOTAL_DROP_OUT, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelID ?? null,
      groupId: groupID ?? null,
      teacherId: teacherId ?? null,
    },
    onCompleted: ({ getTotalStudentDropOutForDashboard }) => {
      setTotalStudentDropOut(getTotalStudentDropOutForDashboard);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  const { refetch: refetchActive } = useQuery(GET_ACTIVE_STUDENT, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelID ?? null,
      groupId: groupID ?? null,
      teacherId: teacherId ?? null,
    },
    onCompleted: ({ getTotalStudentActiveForDashboard }) => {
      setTotalStudentActive(getTotalStudentActiveForDashboard);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  const { refetch: refetchCertificate } = useQuery(GET_CERTIFICATE_OFFER, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelID ?? null,
      groupId: groupID ?? null,
      teacherId: teacherId ?? null,
    },
    onCompleted: ({ getTotalStudentCertificateOffer }) => {
      setTotalStudentCertificateOffer(getTotalStudentCertificateOffer);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  const { refetch: refetchAttendance } = useQuery(GET_OVERALL_ATT_RATE, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelID ?? null,
      groupId: groupID ?? null,
      teacherId: teacherId ?? null,
      startDate: "",
      endDate: "",
    },
    onCompleted: ({ getAttendanceRate }) => {
      setOverallRateData(getAttendanceRate);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
    refetchDropOut();
    refetchActive();
    refetchCertificate();
    refetchAttendance();
  }, [academicYearId, schoolId, levelID, groupID, teacherId]);

  // console.log("totalStudentData",totalStudentData)

  const data = [
    {
      title: t("total-student"),
      bgColor: "#439dde",
      numTotal: totalStudentData?.totalStudent,
      numFemale: totalStudentData?.female,
      icon: <RiUser3Line className="icons" style={{ color: "#439dde" }} />,
    },
    {
      title: t("total_drop_out"),
      bgColor: "#FF7E52",
      numTotal: totalStudentDropOut?.totalStudent,
      numFemale: totalStudentDropOut?.female,
      icon: (
        <RiUserUnfollowLine className="icons" style={{ color: "#FF7E52" }} />
      ),
    },
    {
      title: t("active_student"),
      bgColor: "#24C3D0",
      numTotal: totalStudentActive?.totalStudent,
      numFemale: totalStudentActive?.female,
      icon: <RiUserFollowLine className="icons" style={{ color: "#24C3D0" }} />,
    },
    {
      title: t("att_rate"),
      bgColor: "#31bb38",
      numTotal: overallRateData?.toFixed(),
      numFemale: 0,
      icon: <FaUsers className="icons" style={{ color: "#31bb38" }} />,
    },
    {
      title: t("certificate_offered"),
      bgColor: "#4E76E6",
      numTotal: totalStudentCertificateOffer?.totalStudent,
      numFemale: totalStudentCertificateOffer?.female,
      icon: <GrDocumentUser className="icons" style={{ color: "#4E76E6" }} />,
    },
  ];

  return (
    <div className="dashboard-card-container">
      <Grid container spacing={2}>
        {data?.map((e, index) => {

          return (
            <Grid
              size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 2.4 }}
              key={index}
            >
              <Stack
                direction={`column`}
                className="card-total-student"
                spacing={2}
                sx={{ bgcolor: `${e?.bgColor}` }}
              >
                <Stack direction={`row`} spacing={2} alignItems={`center`}>
                  <Stack
                    direction={`column`}
                    justifyContent={`center`}
                    alignItems={"center"}
                    className="icons-bg"
                  >
                    {e?.icon}
                  </Stack>
                  <Typography
                    className={
                      language === "en" ? "card-title-en" : "card-title-kh"
                    }
                  >
                    {e?.title}
                  </Typography>
                </Stack>

                {
                  index === 3 ? (
                    <Stack
                      direction="row"
                      width={"100%"}
                      justifyContent="space-between"
                    >
                      <Stack direction="column" width={"100%"}>
                        <Typography
                          className={
                            language === "en" ? "txt-title-en" : "txt-title-kh"
                          }
                        >
                          {t("percentage")}
                        </Typography>
                        <Divider
                          sx={{
                            backgroundColor: "#fff", // Custom color
                            height: "2px", // Custom height
                          }}
                        />
                        <Typography
                          mt={1}
                          className={
                            language === "en" ? "txt-num-en" : "txt-num-kh"
                          }
                        >
                          {e?.numTotal || 0} %
                        </Typography>
                      </Stack>
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      width={"100%"}
                      justifyContent="space-between"
                    >
                      <Stack direction="column" width={"40%"}>
                        <Typography
                          className={
                            language === "en" ? "txt-title-en" : "txt-title-kh"
                          }
                        >
                          {t("total")}
                        </Typography>
                        <Divider
                          sx={{
                            backgroundColor: "#fff", // Custom color
                            height: "2px", // Custom height
                          }}
                        />
                        <Typography
                          mt={1}
                          className={
                            language === "en" ? "txt-num-en" : "txt-num-kh"
                          }
                        >
                          {e?.numTotal}
                        </Typography>
                      </Stack>
                      <Stack direction="column" width={"40%"}>
                        <Typography
                          className={
                            language === "en" ? "txt-title-en" : "txt-title-kh"
                          }
                        >
                          {t("female")}
                        </Typography>
                        <Divider
                          sx={{
                            backgroundColor: "#fff", // Custom color
                            height: "2px", // Custom height
                          }}
                        />
                        <Typography
                          mt={1}
                          className={language === "en" ? "txt-num-en" : "txt-num-kh"}
                        >
                          {e?.numFemale}
                        </Typography>
                      </Stack>
                    </Stack>
                  )
                }
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
